import React from "react";
import { connect } from "react-redux";
import { Modal, Form, message } from 'antd';
import moment from "moment";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";

import DynamicFilter from "../../components/frame/DynamicFilter";
import DynamicButton from "../../components/frame/DynamicButton";
import ReactAbstract from "../../components/abstract/React.abstract";
import LeaveApprovalService from "../../services/Approval/leave-approval-service";
import { fetchDepartmentsList } from '../../actions/department-structure-actions';

class LeaveApproval extends ReactAbstract {

	customComponentWillMount(){
		this.props.fetchDepartmentsList()
	}

	dataMode = 1
	initReload = false
	moduleName = "approval"
	childModuleName = "leaveApproval"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		filters: {},
		data: [],
		dataStatus: "unload",
	}

	actions = {
		selectAction: LeaveApprovalService.selectLeaveApproval,
		createAction: LeaveApprovalService.createLeaveApproval,
		updateAction: LeaveApprovalService.updateLeaveApproval,
		deleteAction: LeaveApprovalService.deleteLeaveApproval,
		exportAction: LeaveApprovalService.exportLeaveApproval,
	}


	filterColumn = [{
			type: "person",
			label:"请输入工号或姓名"
		}, {
			type: "department"
		}, {
			type: "date",
			label: "结束时间",
			key: "search_end_time",
		}, {
			type: "date",
			label: "开始时间",
			key: "search_start_time",
		}
	]

	tableColumn = [{
			title: '工号',
			dataIndex: 'job_number',
			key: 'job_number',
			className: 'table-global-head-small'
		},{
			title: '中文名',
			dataIndex: 'real_name',
			key: 'real_name',
			className: 'table-global-head-small'
		}, {
			title: '英文名',
			dataIndex: 'english_name',
			key: 'english_name',
			className: 'table-global-head'
		}, {
			title: '部门名称',
			dataIndex: 'department_name',
			key: 'department_name',
			className: 'table-global-head'
		}, {
			title: '开始日期',
			dataIndex: 'start_date',
			key: 'start_date',
			className: 'table-global-head-short',
			render:(text)=>(<span>{moment(text).format("YYYY-MM-DD")}</span>)
		}, {
			title: '开始时间',
			dataIndex: 'start_time',
			key: 'start_time',
			className: 'table-global-head-short'
		}, {
			title: '结束日期',
			dataIndex: 'end_date',
			key: 'end_date',
			className: 'table-global-head-short',
			render:(text)=>(<span>{moment(text).format("YYYY-MM-DD")}</span>)
		}, {
			title: "结束时间",
			dataIndex: 'end_time',
			key: 'end_time',
			className: 'table-global-head-short'
		}, {
			title: "时长",
			dataIndex: 'hours',
			key: 'hours',
			className: 'table-global-head-small'
		}, {
			title: '申请原因',
			dataIndex: 'remark',
			key: 'remark',
			className: 'table-global-head'
		}, {
			title: '状态',
			dataIndex: 'approval_status_str',
			key: 'approval_status_str',
			className: 'table-global-head-small'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head-small',
			render: (text, record, index) => (
				<DynamicButton column={this.buttonColumn(text, record, index)}
					module={this.childModuleName}
					access={this.props.access} />
			)
		}
	]

	formColumn = [{
			label: "员工姓名",
			key: "real_name",
			type: "text"
		}, {
			label: "开始日期",
			key: "start_date_str",
			type: "text"
		}, {
			label: '开始时间',
			key: 'start_time',
			type: "text"
		}, {
			label: "结束日期",
			key: "end_date_str",
			type: "text"
		}, {
			label: "结束时间",
			key: 'end_time',
			type: "text"
		}, {
			label: "时长",
			key: 'hours',
			type: "text"
		}, {
			label: '申请原因',
			key: 'remark',
			type: "text"
		}, {
			label: '状态',
			key: 'approval_status_str',
			type: "text"
		}, {
			label: "审批",
			key: "approval_status",
			type: "checkbox",
			children: [
				{id: 1, text: "通过"},
				{id: 2, text: "驳回"}
			]
		}, {
			label: "意见",
			key: "suggestion",
			type: "textarea",
			span: 24,
			valueWidth: "760px",
			rules: {rows: 5}
		}, 
	]

	buttonColumn = (text, record, index) => [{
			size: "small",
			type: "default",
			icon: "edit",
			title: "审批",
			access: "audit_value",
			click: () => this.setState({
				currentModalStatus: true,
				currentDataStatus: "loaded",
				currentIndex: index,
				currentData: this.state.data.Data[index],
			})
		}
	]

	publicUpdate = puts => {
		if ("function" === typeof this.actions.updateAction) {
			this.actions.updateAction(puts, res => {
				if (res.data.Success) {
					this.toggleCurrentModal();
					message.success("修改数据成功", 4);
					this.publicChange({}, "reload")	
				}else{
					if(res.data.Errors && res.data.Errors[0]){
						message.error("修改数据失败 " + res.data.Errors[0], 4);
					}
					else if (res.data.Message){
						message.error("修改数据失败 " + res.data.Message, 4);
					}
				}
			}, err => message.error("修改数据失败, 请联系管理员", 4))
		}else{
			this.handleError("Child class's actions updateAction is required!");
		}
	}

	publicSubmit = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const currentData = {
					...this.state.currentData,
					...values
				}
				const callee = null === this.state.currentIndex ?
					this.publicCreate : this.publicUpdate;
				// console.log(currentData, callee)
				callee(currentData);
			}
		})
	}

	render () {
		return (
			<div className="app-module-item">
				<div className="app-module-header">
					<DynamicFilter column={this.filterColumn}
						departmentsList={this.props.departmentStructure.departmentsList}
						value={this.dataSource().filters}
						setFilter={this.publicChange} />
				</div>
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="审批权限"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.publicSubmit} >
					<DynamicForm column={this.formColumn}
						form={this.props.form}
						loadStatus={this.state.currentDataStatus}
						dataSource={this.state.currentData} />
				</Modal>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.dataSource().dataStatus}
						dataSource={this.dataSource().data.Data}
						pagination={{
							total: this.dataSource().data.Total,
							pageSize: this.dataSource().data.PageSize,
							current: this.dataSource().filters.page}}
						rowSelection={this.rowSelection}
						setPageFilter={this.publicChange} />
				</div>
			</div>
		)
	}
}

LeaveApproval = Form.create()(LeaveApproval);

const mapStateToProps = state => {
	return {
		departmentStructure: state.departmentStructure
	}
}

const mapDispatchToProps = {
	fetchDepartmentsList
}

LeaveApproval = connect(mapStateToProps, mapDispatchToProps)(LeaveApproval);

export default LayoutWrapper(LeaveApproval);


// WEBPACK FOOTER //
// ./src/routes/Approval/LeaveApproval.js